import React from 'react';
import { ButtonSection, Heading, SubHeading, TitleSection } from '../projectDetails/styles';
import { useMobileDevice } from '../../../../../global/useMobile';
import Button from '../../../../../component/button';
import { BUTTON_TYPE } from '../../../../../global/constants';
import { Content, LeftSection } from './styles';
import TemplateListItem from './templateList';
import { rootStore } from '../../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
interface Props {
  onClickUseTemplate: () => void;
  onClickTemplate: () => void;
}
const ProjectTemplate: React.FC<Props> = (props) => {
  const { onClickUseTemplate, onClickTemplate } = props;
  const isMobile = useMobileDevice();
  const { projectStore } = rootStore;
  const { createProjectInput } = projectStore;

  return (
    <>
      <LeftSection className='desktop-create-project-template-section'>
        <TitleSection isProjectTemplate={true}>
          {!isMobile && <Heading>Project templates</Heading>}
          <SubHeading>Select a template to start.</SubHeading>
        </TitleSection>
        <Content>
          <TemplateListItem onClickTemplate={onClickTemplate} />
        </Content>
        {!isMobile && (
          <ButtonSection>
            <Button
              title='Use template'
              variant={BUTTON_TYPE.PRIMARY}
              disabled={!createProjectInput?.templateId}
              onClick={onClickUseTemplate}
            />
          </ButtonSection>
        )}
      </LeftSection>
    </>
  );
};

export default observer(ProjectTemplate);
